import { render } from "./chart4.vue?vue&type=template&id=032e0b5c&scoped=true&ts=true"
import script from "./chart4.vue?vue&type=script&lang=ts"
export * from "./chart4.vue?vue&type=script&lang=ts"

import "./chart4.vue?vue&type=style&index=0&id=032e0b5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032e0b5c"]])

export default __exports__